import { useState } from "react";
import { motion } from "framer-motion";
import { projectsData } from "../data";

function Projects() {
  const [hoveredProject, setHoveredProject] = useState(null);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section className="py-20 bg-gray-50" id="projects">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={containerVariants}
          className="max-w-6xl mx-auto"
        >
          <motion.div variants={itemVariants} className="text-center mb-12">
            <span className="text-primary font-medium">My Work</span>
            <h2 className="text-3xl md:text-4xl font-bold text-dark mt-2">
              Featured Projects
            </h2>
            <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
            <p className="text-gray-600 mt-6 max-w-2xl mx-auto">
              Here are some of my recent projects that showcase my skills and
              expertise in web development.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projectsData.map((project, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                onMouseEnter={() => setHoveredProject(index)}
                onMouseLeave={() => setHoveredProject(null)}
                className="card group relative overflow-hidden bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={project.photoName}
                    alt={project.imageAlt || project.name}
                    className="w-full h-full object-contain object-center transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div
                    className={`absolute inset-0 bg-primary/30 backdrop-blur-sm flex items-center justify-center transition-opacity duration-300 ${
                      hoveredProject === index ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <div className="flex space-x-3">
                      <a
                        href={project.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn bg-white text-primary hover:bg-primary hover:text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-300"
                        aria-label={`View live demo of ${project.name}`}
                      >
                        Live Demo
                      </a>
                      <a
                        href={project.source}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn bg-dark text-white hover:bg-dark/80 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-300"
                        aria-label={`View source code of ${project.name} on GitHub`}
                      >
                        Source Code
                      </a>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-dark mb-2 group-hover:text-primary transition-colors duration-300">
                    {project.name}
                  </h3>
                  <p className="text-gray-600">{project.description}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div variants={itemVariants} className="text-center mt-12">
            <a
              href="https://github.com/AbdllhAlioglu"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline inline-block"
              aria-label="View more projects on GitHub profile"
            >
              View More on GitHub
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Projects;
